// extracted by mini-css-extract-plugin
module.exports = {"component":"facet-ClearActiveFacetsByGroupButton__component--vcED6"};